import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import { X } from 'lucide-react';
import PropTypes from 'prop-types';

import { ContactDetailSideSkeleton, ContactDetailSkeleton } from './skeleton';

export const ContactDetailLoader = ({ onCloseView }) => (
  <Flex flexDirection="column" flexGrow="1" width="100%">
    <Flex
      as="header"
      alignItems="center"
      justifyContent="space-between"
      height="40px"
      px="4px"
      sx={{ borderBottom: '1px solid', borderColor: 'border.subtle' }}
    >
      <Flex
        data-testid="close-button"
        alignItems="center"
        justifyContent="center"
        width="40px"
        height="40px"
        color="neutral.400"
        sx={{
          cursor: 'pointer',
        }}
        onClick={onCloseView}
      >
        <Box as={X} width="16px" height="16px" aria-hidden="true" />
      </Flex>
    </Flex>

    <Flex width="100%" flexDirection="row-reverse" flexGrow="1">
      <Box
        width={['100%', '100%', 'calc(100% - 40px)']}
        maxWidth="1100px"
        pl={[0, 0, '16px']}
        sx={{ borderLeftWidth: [0, 0, 1], borderLeftStyle: 'solid', borderLeftColor: 'neutral.100' }}
      >
        <ContactDetailSkeleton />
      </Box>

      <Box flex="0 0 auto" width={['100%', '100%', '320px']}>
        <ContactDetailSideSkeleton />
      </Box>
    </Flex>
  </Flex>
);

ContactDetailLoader.propTypes = {
  onCloseView: PropTypes.func.isRequired,
};
